import $ from 'jquery';
import DocumentLabelModal from '@/views/analyse/registre_analyse/components/DocumentLabelModal.vue';
import PreviewGroupedAnalysesModal from '@/views/analyse/registre_analyse/components/PreviewGroupedAnalysesModal.vue';
import PrintedGroupedAnalysis from '@/views/analyse/registre_analyse/components/PrintedGroupedAnalysis.vue';
import VoirResultat from '@/views/analyse/visualiser-resultat';

import ResultatPatientModal from '@/views/analyse/registre_analyse/resultat-patient-modal'
import store_analyse from '@/store/mods/analyses/analyse'

export default {
    name: 'registre-patient',
    components: {
        DocumentLabelModal, PreviewGroupedAnalysesModal, 
        PrintedGroupedAnalysis, VoirResultat,
        ResultatPatientModal
    },
    props: {
        patient: {
            type: Object,
            required: true
        },
        user_id: Number,
        current_date_filter: Object
    },
    data() {
        return {
            tableHeadCells: [
                { key: 'nom_analyse', label: 'Analyses' },
                { key: 'technique_utilisee', label: 'Technique utilisée' },
                { key: 'resultat_est_porte', label: 'Résultat' },
            ],
            currentPage: 1,
            perPage: -1,
            isLoading: false,
            groupedResultsToggled: false,
            groupResults: [],
            isSavingDocument: false,
            isSuccess: false,

            result_preview: {},

            isNewResultFetching: false,

            results: undefined,
            showPrintedResults: false,
            view_result_loading: false,
            can_print: false,
            liste_analyses: [],
            toggler: 0,

            bull_is_loading: true,
            bull_is_empty: false,
            is_error: false,
            liste_patient_bulletins: [],

            checked_items: [],
            one_checked: [],
            all_grp_checked: [],
            can_group: false
        }
    },

    watch: {
        patient() {
            this.groupResults = [];
            this.showPrintedResults = false;
            this.getBulletinPatient(this.patient.id)
        },

        groupedResultsToggled: {
            handler: function (newValue) {
                if (newValue) {
                    this.tableHeadCells.push({ key: 'action', label: 'Action(s)' });
                } else {
                    this.tableHeadCells.pop();

                    this.patientBulletins.forEach(b => {
                        b.checked = false;
                        b.demandes_analyses.forEach(d => d.checked = false);
                    });
                }
                this.groupResults = [];
            }
        },

        showPrintedResults: {
            handler: function (newValue) {
                this.can_group = false;
                if (newValue) {
                    this.groupedResultsToggled = false;
                    this.$store.dispatch('getGroupedAnalysesByPatientId', this.patient.id);
                }
            }
        },

        current_date_filter() {
            this.getBulletinPatient(this.patient.id)
        },

        one_checked() {
            this.can_group = this.one_checked.length > 1
        },

        all_grp_checked() {
        }
    },

    computed: {
        patientBulletins() {
            return this.$store.getters.patientBulletins;
        },

        showNextStepButton() {// Il faut au moins 02 demandes sinon ça n'as pas de sens
            const demandesCount = this.groupResults.reduce((total, bulletin) => {
                return total + bulletin.demandes_analyses.length;
            }, 0);

            return demandesCount >= 2;
        },

        patientPrintedGroupedResults() {
            return this.$store.getters.patientPrintedGroupedResults;
        }
    },

    mounted() {
        this.getBulletinPatient(this.patient.id)
    },
    
    methods: {
        getBulletinPatient(patient_id) {
            this.liste_patient_bulletins = []
            this.bull_is_loading = true

            const data = {
                patient_id: patient_id,
                month: this.current_date_filter.month,
                one_date: this.current_date_filter.one_date,
                from_date: this.current_date_filter.from_date,
                to_date: this.current_date_filter.to_date,
            }

            store_analyse.getBulletinAnalysesPatient(data).then((response) => {
                this.liste_patient_bulletins = response

                if (response.length == 0) {
                    this.bull_is_empty = true
                } else {
                    this.bull_is_empty = false
                }

                this.bull_is_loading = false
            }).catch(() => {
                this.bull_is_loading = false
                this.is_error = true
            })
        },
        
        async handleResultatAnalyse(item, bulletin_id) {
            console.log("I: ",item, " >> ",bulletin_id);
            
            this.toggler = (this.toggler == 0)?1:0
            this.view_result_loading = true
            if (this.is_modele_analyse) {
                if (item.resultat_est_porte == 1 && item.resultat_fichier == null) {
                    $("#view-analysis-modal").modal('show');
    
                    const param = {
                        analyseId: item.analyse_id,
                        bulletinId: bulletin_id
                    }
                    this.$store.dispatch("getResultsByAnalyseIdBulletinId", param).then((response) => {
                        this.results = response.data
                        this.view_result_loading = false
                    })
                } else {
                    const demande = {
                        analyse_nom: item.nom_analyse,
                        resultat_fichier: item.resultat_fichier,
                        commentaires: item.commentaires
                    };
        
                    this.result_preview = demande;
                    $('#modalResultat').modal('show');
                }
            } else {
                const demande = {
                    analyse_nom: item.nom_analyse,
                    resultat_fichier: item.resultat_fichier,
                    commentaires: item.commentaires
                };
    
                this.result_preview = demande;
                $('#modalResultat').modal('show');
            }
        },

        toggleGroupResults() {
            this.groupedResultsToggled = !this.groupedResultsToggled;
            this.showPrintedResults = false;
        },

        handleAllCheck(bulletin, bindex) {
            let is_checked = $('#catbull'+bulletin.id).is(":checked")
            
            if (!is_checked) {
                this.liste_patient_bulletins.forEach((bulletin, index) => {
                    if (bindex == index) {
                        bulletin['demandes_analyses'].forEach((demande) => {
                            
                            this.one_checked.forEach((el, oi) => {
                                if (el == demande.demande_id) {
                                    this.handleOneCheck(bulletin, demande, 1)
                                    this.one_checked.splice(oi, 1)
                                }
                            });
                        });
                    }
                });
            } else {
                // this.one_checked = []
                this.liste_patient_bulletins.forEach((bulletin, index) => {
                    // auto check all demande
                    if (is_checked && bindex == index) {
                        bulletin['demandes_analyses'].forEach((demande) => {
                            if (demande.resultat_est_porte == 1) {
                                this.one_checked.push(demande.demande_id)

                                this.handleOneCheck(bulletin, demande, 1)
                            }
                        });
                    }
                });
            }
        },

        handleOneCheck(bulletin, demande, is_check_all=0) {
            const index = this.checked_items.findIndex(item => item.id === bulletin.id);

            if (index !== -1) {
                this.checked_items.forEach((citem, cindex) => {
                    const demande_index = citem['demandes_analyses'].findIndex(item => item === demande.demande_id);
                    
                    if (bulletin.id == citem['id']) {
                        if (demande_index !== -1) {
                            if (is_check_all == 0) {
                                this.checked_items[cindex]['demandes_analyses'].splice(demande_index, 1);
                            }

                            if (this.checked_items[cindex]['demandes_analyses'].length == 0) {
                                this.checked_items.splice(cindex, 1);
                            }
                        } else {
                            this.checked_items[cindex]['demandes_analyses'].push(demande.demande_id)
                        }
                    }
                    
                });
            } else {
                const tmp_demande = []
                tmp_demande.push(demande.demande_id)
                this.checked_items.push({
                    id: bulletin.id,
                    demandes_analyses: tmp_demande
                });
            }
        },

        async handleSaveGroupedAnalyses(documentDetails) {

            const groupedAnalysisObject = {
                data: {
                    ...documentDetails,
                    bulletins: this.checked_items,
                    saved_by: this.user_id,
                },
                patientId: this.patient.id,
            };

            // this.isSavingDocument = true;

            this.$store.dispatch('saveGroupedAnalyses', groupedAnalysisObject).then((response) => {
                console.log(response);

                if (response.status === 201 || response.status === 200) {
                    this.successToast('Document prêt pour la prévisualisation');

                    this.groupedResultsToggled = false;
                    this.groupResults = [];

                    this.$bvModal.hide('document-label-modal');
                    // setTimeout(() => {
                    //     $('#preview-grouped-analyses-modal').modal('show');
                    // }, 200);
                } else {
                    this.errorToast("Une erreur est survenue lors de l’enregistrement du document")
                }
                            
                // if (response.status === 201 || response.status === 200) {
                //     this.isSuccess = true;
                    
                //     this.successToast('Document prêt pour la prévisualisation');

                //     this.groupedResultsToggled = false;
                //     this.groupResults = [];

                //     this.$bvModal.hide('document-label-modal');
                //     setTimeout(() => {
                //         $('#preview-grouped-analyses-modal').modal('show');
                //     }, 200);
                // } else{
                //     this.errorToast('Une erreur est survenue lors de l’enregistrement du document');
                // }
                
                this.isSavingDocument = false;
            }).catch(() => {
                this.isSavingDocument = false;
            })
        },

        printResultatAnalyse(results) {
            this.$emit('emitPrintResultat', results)
        },

        groupedResultToPrint(results) {
            this.$emit('emitPrintGroupedResultat', results)
        }
    }
}